export function isSuccessAuthCallbackResponse(response) {
    return response.status === "success";
}
export class Authorization {
    constructor(appController) {
        this._appController = appController;
    }
    async logoutAsync() {
        await this._appController.sdk.authManager.logoutAsync();
    }
    async loginAsUserWithTokenAsync(username, partnerToken, partnerUserId) {
        await this._appController.sdk.authManager.loginAsync(username, partnerUserId, partnerToken);
    }
}
